export const handleRegionChange = (regionId: string) => {
  const currentRoot = window.location.origin;
  const currentPage = window.location.pathname.replace(/^\/emea/, "");
  const targetPath = regionId === "global" ? currentPage : `/emea${currentPage}`;
  const fullTargetPath = `${currentRoot}${targetPath}`;

  if (window.location.href !== fullTargetPath) {
      localStorage.setItem("hasVisitedPopup", "true");
      window.location.href = fullTargetPath;
  }
};
